import { Model } from '@/app/shared/models/model';
import { TranslateResult } from 'vue-i18n';

export class InteractionModel extends Model {
  public ActionCode!: string | TranslateResult;
  public Description!: string | TranslateResult;
  public User!: {
    Id: string;
    Name: string;
  };
  public Created?: Date;
  public Updated?: Date;

  constructor(
    ActionCode: string | TranslateResult = '',
    Description: string | TranslateResult = ''
  ) {
    super();
    this.ActionCode = ActionCode;
    this.Description = Description;
  }
}
